var MTA = {
  // 自定义事件
  ID_PAY_WITH_REFERRER: 'paywithreferrer',
  ID_TESLA_INVITE_MORE: 'teslainvitemore',
  ID_TESLA_INVITE_CARD: 'teslainvitecard',
  // 自定义漏斗
  ID_FUNNEL_JOIN_GENERAL: 'join-2',
  ID_FUNNEL_MONITOR_INVITE_CARD_JOIN: '13jieduichangya',
  ID_FUNNEL_13_INVITE_CARD_1: '13jietongyongya',
  ID_FUNNEL_13_INVITE_CARD_2: '13jietongyongya-1',
  ID_FUNNEL_13_INVITE_CARD_3: '13jietongyongya-2',
  ID_FUNNEL_13_INVITE_CARD_4: '13jietongyongya-3',
  ID_FUNNEL_13_INVITE_CARD_5: '13jietongyongya-6',
  ID_FUNNEL_13_INVITE_CARD_6: '13jietongyongya-7',
  ID_FUNNEL_13_INVITE_CARD_7: '13jietongyongya-8',
  // todo: 存在bug，将两张邀请卡的数据统计到了一个漏斗
  ID_FUNNEL_13_INVITE_CARD_8: '13jietongyongya-3',
  ID_FUNNEL_13_INVITE_CARD_9: '13jietongyongya-9',
  ID_FUNNEL_13_INVITE_CARD_10: '13jietongyongya-10',
  ID_FUNNEL_13_TEAM_INVITE_CARD: '13jieduiwuyaoqi',
  ID_FUNNEL_13_TEAM_INVITE_CARD_2: '13jieduiwuyaoqi-1',
  ID_FUNNEL_13_TEAM_INVITE_CARD_3: '13jieduiwuyaoqi-2',
  ID_FUNNEL_NUMBER_CLOTH: '13jiehaomabubao',
  ID_FUNNEL_14_TEAM_INVITE_CARD_1: '14jieduiwuyaoqi',
  ID_FUNNEL_14_TEAM_INVITE_CARD_2: '14jieduiwuyaoqi-1',
  ID_FUNNEL_14_TEAM_INVITE_CARD_3: '14jieduiwuyaoqi-2',
  ID_FUNNEL_14_TEAM_INVITE_CARD_4: '14jieduiwuyaoqi-3',
  ID_FUNNEL_14_INVITE_CARD_1: '14jietongyongya',
  ID_FUNNEL_14_INVITE_CARD_2: '14jietongyongya-1',
  ID_FUNNEL_14_INVITE_CARD_3: '14jietongyongya-2',
  ID_FUNNEL_14_INVITE_CARD_4: '14jietongyongya-3',
  ID_FUNNEL_14_INVITE_CARD_5: '14jietongyongya-4',
  ID_FUNNEL_14_INVITE_CARD_6: '14jietongyongya-5',
  ID_FUNNEL_14_INVITE_CARD_7: '14jietongyongya-6',
  ID_FUNNEL_14_INVITE_CARD_8: '14jietongyongya-7',
  ID_FUNNEL_14_JMSXY: '14jiejiaomuyaoq',
  ID_FUNNEL_14_TESLA: '14jieteslabaomi'
};
export default MTA;